/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAddress} from '../api'

 export const useQueryGetAddress = createReactQueryHook('getAddress', getAddress)
